import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CookieSafeAreaContext = /*#__PURE__*/createContext([]);
export var useCookieBannerHeight = function useCookieBannerHeight() {
  var _useContext = useContext(CookieSafeAreaContext),
    _useContext2 = _slicedToArray(_useContext, 1),
    height = _useContext2[0];
  return height;
};
export var useCookiBannerHeightSetter = function useCookiBannerHeightSetter() {
  var _useContext3 = useContext(CookieSafeAreaContext),
    _useContext4 = _slicedToArray(_useContext3, 2),
    setCookieBannerHeight = _useContext4[1];
  return setCookieBannerHeight;
};
var CookieSafeAreaProvider = function CookieSafeAreaProvider(_ref) {
  var children = _ref.children;
  var cookieBannerHeightState = useState();
  return /*#__PURE__*/_jsx(CookieSafeAreaContext.Provider, {
    value: cookieBannerHeightState,
    children: children
  });
};
CookieSafeAreaProvider.displayName = 'CookieSafeAreaProvider';
CookieSafeAreaProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export default CookieSafeAreaProvider;